import { ConditionType, SortOrder } from './search/searchTypes';
export const HYPER_USERS_GROUP = 'hyperUsers';
export const HYPER_ADMINS_GROUP = 'hyperAdmins';
export const PLATFORM_ADMINS_GROUP = 'hyperPlatformAdmins';
export const HYPER_BI_USERS_GROUP = 'hyperBIUsers';
export const APP_ADMIN = 'APP_ADMIN';
export const PORTAL_PERMISSION = 'PORTAL';
export const PLATFORM_ADMIN_PERMISSION = 'PLATFORM_ADMIN';
export const PROCESS_CANCELLATION_PERMISSION = 'PROCESS_CANCELLATION';
export const CONTACT_DEFINITION_ID = 'contact';
export const ORG_DEFINITION_ID = 'organization';
export const GROUP_DEFINITION_ID = 'group';
export const DOMAIN_DEFINITION_ID = 'domain';
export const PERMISSION_DEFINITION_ID = 'permission';
export const ALL_PROCESSES_DEFINITION_ID = 'allProcesses';
export const ALL_TASKS_DEFINITION_ID = 'allTasks';
export const PERMISSIONS_ES_PROPERTY_ID = 'permissions'; // viewGroups
export const PERMISSIONS_UPDATE_ES_PROPERTY_ID = 'permissionsUpdate';
export const ALL_ENTITY_ID = '==ALL==';
export const SYSTEM_USER = 'system';
export const HYPERPORTAL_JWT_AUDIENCE = 'HYPER';
export const MAX_SEARCH_LIMIT = 500;
export const DEFAULT_SEARCH_REQUEST = {
    sortBy: [
        {
            field: 'createdAt',
            order: SortOrder.asc
        }
    ],
    query: {
        condition: ConditionType.and,
        filters: []
    },
    offset: 0,
    limit: MAX_SEARCH_LIMIT,
    languageCode: 'en',
    responseFields: ['*'],
    fullText: '',
    fullTextFields: ['title']
};
export const ENTITY_ID_PROPERTY_ID = 'entityId';
export const PLATFORM_ADMIN_PROPERTY_ID = 'platformAdmin';
export const PERMISSIONS_PROPERTY_ID = 'rowPermissions';
export const DEFAULT_ENTITY_COMPUTED_PROPERTY_ID = 'title';
export const MAX_SUPPORTED_NESTED_PATH_DEPTH = 5;
export const PUBLISH_BATCH_CHUNK_SIZE = 10;
export const PERMISSIONS_PROPERTY_ID_SYSTEM_VIEW_VALUE = {
    view: {
        [HYPER_ADMINS_GROUP]: {
            isEnabled: true
        },
        [HYPER_USERS_GROUP]: {
            isEnabled: true
        }
    },
    write: {
        [HYPER_ADMINS_GROUP]: {
            isEnabled: true,
            properties: ['filters', 'metrics', 'viewType', 'configuration']
        },
        [HYPER_USERS_GROUP]: {
            isEnabled: true,
            properties: ['filters', 'metrics', 'viewType', 'configuration']
        }
    }
};
//# sourceMappingURL=constants.js.map